var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-crumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:index,class:{ 'click-bread': index < _vm.len },nativeOn:{"click":function($event){return _vm.breadPath(item, index)}}},[_vm._v(_vm._s(item.meta.titleShow))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }